import { Controller } from '@hotwired/stimulus';
import { dismissOneSignalBanner, isSubscribedToOneSignal, shouldNotifyThatOneSignalDisabled } from '../../median-bridge/onesignal';

export default class extends Controller {
  static values = {
    enabled: Boolean,
    bannerVisible: Boolean
  }

  dismissForDevice(event) {
    dismissOneSignalBanner()
    this.refreshState()
  }

  async connect() {
    this.refreshState()
    window.addEventListener(`punchpass-median:resumed`, this.refreshState.bind(this))
  }

  async refreshState() {
    this.enabledValue = await isSubscribedToOneSignal()
    this.bannerVisibleValue = shouldNotifyThatOneSignalDisabled()
  }

  async openSettings() {
    window.PunchpassMedian.sendEvent(`open-app-settings`)
  }
}
